import React from 'react'

interface AccentTextProps {
  children: React.ReactNode
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'div'
  className?: string
  glow?: boolean
  style?: React.CSSProperties
}

export const AccentText: React.FC<AccentTextProps> = ({
  children,
  as: Component = 'span',
  className = '',
  glow = false,
  style,
}) => {
  return (
    <Component
      className={className}
      style={{
        color: 'var(--accent)',
        textShadow: glow ? '0px 2px 10px rgba(var(--accent-glow-rgba), 0.2)' : 'none',
        ...style,
      }}
    >
      {children}
    </Component>
  )
}

/** @deprecated Use AccentText instead */
export const GoldText = AccentText

export default AccentText
